import {useMemo} from "react";
import {useAuth} from "react-oidc-context";
import {
  extractRolesFromProfile,
  isAdminByProfile,
  canWriteByProfile,
  isReadonlyByProfile,
  hasAppAccessByProfile,
} from "./authorization";

const useAuthorization = () => {
  const auth = useAuth();

  return useMemo(() => {
    const profile = auth.user?.profile;
    const roles = extractRolesFromProfile(profile);

    return {
      roles,
      isAdmin: isAdminByProfile(profile),
      canWrite: canWriteByProfile(profile),
      isReadonly: isReadonlyByProfile(profile),
      hasAppAccess: hasAppAccessByProfile(profile),
      isAuthenticated: auth.isAuthenticated,
      user: auth.user,
    };
  }, [auth.user, auth.isAuthenticated]);
};

export default useAuthorization;
